import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Table } from 'reactstrap';
import { metadataService } from "../../_services";


export class AccountActivity extends Component {

    render(){
        return (
            <Table striped>
                <thead>
                    <tr>
                        <th>{metadataService.getLabel('AccountActivityDate')}</th>
                        <th>{metadataService.getLabel('AccountActivityAmount')}</th>
                        <th>{metadataService.getLabel('AccountActivityConvenienceFee')}</th>
                        <th>{metadataService.getLabel('AccountActivityToBalance')}</th>
                        <th>{metadataService.getLabel('AccountActivityToOther')}</th>
                        <th>{metadataService.getLabel('AccountActivityBalance')}{this.props.showAsterisk && (<span>*</span>)}</th>
                    </tr>
                </thead>
                <tbody>
                {this.props.accountActivity.map(function(item) {
                    return (
                        <tr key={item.paymentId}>
                            <td>{metadataService.formatDateString(item.paymentDate)}</td>
                            <td>{metadataService.formatMoney(item.paymentAmount)}</td>
                            <td>{metadataService.formatMoney(item.toConvenienceFee)}</td>
                            <td>{metadataService.formatMoney(item.toBalance)}</td>
                            <td>{metadataService.formatMoney(item.toOther)}</td>
                            <td>{metadataService.formatMoney(item.balance)}</td>
                        </tr>
                    )
                })}
                </tbody>
            </Table>
        )
    }
}

AccountActivity.propTypes = {
    accountActivity: PropTypes.array.isRequired, 
    showAsterisk: PropTypes.bool
}